<div
  id="sell_property_form_step_2"
  [formGroup]="propertyForm"
  class="form-body saler-step-form"
>
  <h3 class="fb-title">
    {{ "components.stepBasics.sellWithTenantMaximize" | translate }}
  </h3>
  <section class="container-datos">
    <div class="dato">
      <span class="mandatory">
        {{ "components.detailsPropPortal.propertyType" | translate }}
      </span>
      <mat-select formControlName="propertyType" class="w100 large">
        <mat-option [value]="null" hidden selected>
          {{ "components.stepBasics.selectTypeDefault" | translate }}
        </mat-option>
        <mat-option
          *ngFor="let type of propertyTypes"
          [value]="type.id_prop_type"
        >
          {{ type["description" + language] }}
        </mat-option>
      </mat-select>
    </div>
    <div class="dato">
      <span>{{
        "components.stepBasics.isPropertyRented" | translate
      }}</span>
      <mat-radio-group
        (change)="onOcupationToggle()"
        formControlName="ocupation_state"
        style="display: flex; gap: 15px"
        class="large"
      >
        <mat-radio-button color="primary" [value]="true">
          <span class="checkboxes">{{
            "components.propertyDetails.Si" | translate
          }}</span>
        </mat-radio-button>
        <mat-radio-button color="primary" [value]="false">
          <span class="checkboxes">{{
            "components.propertyDetails.No" | translate
          }}</span>
        </mat-radio-button>
        <mat-radio-button color="primary" [value]="null">
          <span class="checkboxes">{{
            "components.propertyDetails.Otras situaciones" | translate
          }}</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="dato" *ngIf="propertyForm.get('ocupation_state')?.value">
      <span class="mandatory">{{
        "components.cardCharacProp.rentalAmount" | translate
      }}</span>
      <input
        formControlName="rent_price"
        class="w100 large"
        appMaxLength
        [maxLength]="12"
        type="text"
        placeholder="{{
          'components.stepBasics.enterRentalValue' | translate
        }}"
      />
    </div>
    <div class="dato" *ngIf="!propertyForm.get('ocupation_state')?.value">
      <span>{{
        "components.stepBasics.describeCurrentSituation" | translate
      }}</span>
      <textarea
        formControlName="desc_state"
        class="w100 large"
        style="resize: none; height: 70px"
      ></textarea>
    </div>
  </section>
  <div>
    <small *ngIf="submited && propertyForm.invalid" class="text-danger">
      {{ "components.wizard.mustComplete" | translate }}
    </small>
  </div>
  <button
    type="button"
    class="submit-btn"
    [disabled]="propertyForm.invalid || isLoadingSubmit"
    (click)="submit.emit()"
  >
    <span *ngIf="!isLoadingSubmit">{{ "components.ingreso.Enviar" | translate }}</span>
    <mat-progress-spinner
      *ngIf="isLoadingSubmit"
      mode="indeterminate"
      color="primary"
      [diameter]="20"
    ></mat-progress-spinner>
  </button>
</div>
